import { PlayerJumpingStateConstants } from "../Constants/PlayerJumpingStateConstants";
import { AABB } from "../Utils/AABB";
import { Point } from "../Utils/Point";

export class PlayerModel {
    public id = '1';
    public name = 'player';
    public totalScore = 0;
    public score = 0;

    public jumpingState: PlayerJumpingStateConstants = PlayerJumpingStateConstants.None;
    public jumpAccelerationY: number = 0;
    public jumpSpeedY: number = 0;
    public jumpStartAt: number = 0;
    public speed: number = 2;
    public readonly initPos: Point = Object.freeze(new Point(300, 0));
    public pos: Point = new Point(this.initPos.x, this.initPos.y);

    public lives: number = 3;
    public isFall: boolean = false;
    public fallAt: number = 0;
    public isRun:  boolean = false;

    get aabbComposite() {
        return [
            new AABB(new Point(this.pos.x - 50 , this.pos.y - 436), new Point(this.pos.x + 110, this.pos.y))
        ];
    }
}